var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14ZM10.6665 10.6665C10.8507 10.4823 10.8507 10.1837 10.6665 9.99956L8.66675 7.99976L10.6665 6.00044C10.8507 5.81628 10.8507 5.51767 10.6665 5.33349C10.4823 5.14931 10.1837 5.14933 9.99956 5.33352L8.00024 7.33325L6.00044 5.33346C5.81627 5.14929 5.51769 5.14929 5.33352 5.33346C5.14933 5.51765 5.14936 5.81629 5.33359 6.00044L7.33373 7.99976L5.33352 9.99956C5.14933 10.1837 5.14931 10.4823 5.33349 10.6665C5.51767 10.8507 5.81628 10.8507 6.00044 10.6665L8.00024 8.66627L9.99956 10.6664C10.1837 10.8506 10.4824 10.8507 10.6665 10.6665Z",
    fill: "#F74527"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.82075a60d9f520a0a96cded5d757971e.svg";
export { ForwardRef as ReactComponent };